import type { WCmsPageView } from '@zola/svc-web-api-ts-client';
import type { AppDispatch, RootState } from 'reducers/index';

import { updatePage, updatePageSilently } from 'actions/website/PageActions';
import { connect } from 'react-redux';
import type { RouteComponentProps } from 'react-router';

import { updatePreview } from 'actions/website/WebsitePreviewActions';

import { uploadPhoto } from 'actions/website/FileUploadActions';
import { EditPageFormV2WithRouter } from './EditPageFormV2';
import type { UploadedImage } from '../../../../../../../api/svc-image';

type PreviewType = {
  title: string;
  description: string;
  hidden: boolean;
  header_image_url: string;
};

export type EditPageV2OwnProps = {
  page: WCmsPageView;
  // valid: boolean;
  // router: InjectedRouter;
  // routes: PlainRoute[];
};

export type EditPageFormV2StateProps = {
  form?: string;
  initialValues: WCmsPageView;
  filePreview: UploadedImage;
  headerImgUrl?: string;
  headerImgId?: string;
  isFormDirty?: boolean;
};

export type EditPageFormV2DispatchProps = {
  submitPage: (pageView: WCmsPageView) => Promise<void>;
  submitPageSilently: (pageView: WCmsPageView) => Promise<void>;
  onUpload: (file: File, onFailCB: () => void) => void;
  updatePreview: (preview: PreviewType) => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type EditPageV2Props = RouteComponentProps<any, any> &
  EditPageV2OwnProps &
  EditPageFormV2StateProps &
  EditPageFormV2DispatchProps;

const getFormIdentifier = (pageType?: string) => {
  return (pageType && `${pageType.toLowerCase()}EditPageForm`) || 'EditPageForm';
};

const mapStateToProps = (
  state: RootState,
  ownProps: EditPageV2OwnProps
): EditPageFormV2StateProps => {
  const { page } = ownProps;
  const pageType = page && page.type;

  return {
    form: getFormIdentifier(pageType),
    initialValues: page,
    filePreview: state.website.entities.filePreview[`header_image_${pageType}`] || {},
    headerImgUrl: page.header_image_url,
    headerImgId: page.header_image_id,
  };
};

const mapDispatchToProps = (
  dispatch: AppDispatch,
  ownProps: EditPageV2OwnProps
): EditPageFormV2DispatchProps => {
  const { page } = ownProps;
  const pageType = page && page.type;

  return {
    submitPage: (pageView: WCmsPageView) => dispatch(updatePage(pageView)),
    submitPageSilently: (pageView: WCmsPageView) => dispatch(updatePageSilently(pageView)),
    onUpload: (file, onFailCB) => dispatch(uploadPhoto(file, `header_image_${pageType}`, onFailCB)),
    updatePreview: (preview: PreviewType) => dispatch(updatePreview(preview)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditPageFormV2WithRouter);
